"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAffordableSocialSecurityData = exports.affordableSocialSecurityFormRules = exports.affordableSocialSecuritySchema = void 0;
const converters_1 = require("../../converters");
const income_1 = require("./income");
exports.affordableSocialSecuritySchema = {
    fields: {
        frequency: {
            required: true,
        },
        social_security_claim_number: {
            required: true,
            maxLength: 12,
        },
    },
    messages: {
        social_security_claim_number: {
            maxLength: 'Social Security Claim Number must be 12 characters or less',
        },
        frequency: {
            required: 'Frequency is required',
        },
    },
};
// 🚀 Pre-computed validations for performance
exports.affordableSocialSecurityFormRules = (0, converters_1.toReactHookForm)(exports.affordableSocialSecuritySchema, income_1.incomeFieldMapping);
exports.validateAffordableSocialSecurityData = (0, converters_1.createValidator)(exports.affordableSocialSecuritySchema);
